"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentType = exports.TertiaryResultType = exports.TertiaryLevel = exports.Profession = void 0;
var Profession;
(function (Profession) {
    Profession["ARCH"] = "Architecture, building, planning and design";
    Profession["ARTS"] = "Arts, humanities and social sciences";
    Profession["BUSS"] = "Business and economics";
    Profession["EDU"] = "Education";
    Profession["ENG"] = "Engineering";
    Profession["ENV"] = "Environment";
    Profession["HEA"] = "Health";
    Profession["ITC"] = "Information technology and computer science";
    Profession["LAW"] = "Law";
    Profession["MPA"] = "Music, visual and performing arts";
    Profession["SCI"] = "Science";
    Profession["VET"] = "Veterinary, agricultural and food sciences";
})(Profession = exports.Profession || (exports.Profession = {}));
var TertiaryLevel;
(function (TertiaryLevel) {
    TertiaryLevel["ADVANCED_DIPLOMA"] = "Advanced Diploma";
    TertiaryLevel["ASSOCIATE_DEGREE"] = "Associate Degree";
    TertiaryLevel["BACHELOR_HONOURS"] = "Bachelor Honours";
    TertiaryLevel["BACHELOR"] = "Bachelor";
    TertiaryLevel["CERT_I"] = "Certificate I";
    TertiaryLevel["CERT_II"] = "Certificate II";
    TertiaryLevel["CERT_III"] = "Certificate III";
    TertiaryLevel["CERT_IV"] = "Certificate IV";
    TertiaryLevel["DIPLOMA"] = "Diploma";
    TertiaryLevel["DOCTORAL_DEGREE"] = "Doctoral Degree";
    TertiaryLevel["GRADUATE_DEGREE"] = "Graduate Certificate";
    TertiaryLevel["GRADUATE_DIPLOMA"] = "Graduate Diploma";
    TertiaryLevel["HIGHER_DOCTORAL_DEGREE"] = "Higher Doctoral Degree";
    TertiaryLevel["HONOURS_YEAR"] = "Honours Year";
    TertiaryLevel["MASTERS_COURSEWORK"] = "Masters (Coursework)";
    TertiaryLevel["MASTERS_RESEARCH"] = "Masters (Research)";
    TertiaryLevel["SENIOR_CERT_EDU"] = "Senior Secondary Certificate of Education";
    TertiaryLevel["STATEMENT_ATTAINMENT"] = "Statement of Attainment";
    TertiaryLevel["UNDERGRAD_CERT"] = "Undergraduate Certificate";
})(TertiaryLevel = exports.TertiaryLevel || (exports.TertiaryLevel = {}));
var TertiaryResultType;
(function (TertiaryResultType) {
    TertiaryResultType["NUMERIC"] = "NUMERIC";
    TertiaryResultType["GRADING"] = "GRADING";
    TertiaryResultType["PASS_FAIL"] = "PASS/FAIL";
})(TertiaryResultType = exports.TertiaryResultType || (exports.TertiaryResultType = {}));
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["FULL_TIME"] = "Full time";
    EmploymentType["PART_TIME"] = "Part time";
    EmploymentType["CASUAL"] = "Casual";
    EmploymentType["CONTRACT"] = "Contract";
    EmploymentType["SELF_EMPLOYED"] = "Self employed";
})(EmploymentType = exports.EmploymentType || (exports.EmploymentType = {}));
//# sourceMappingURL=MatchingCriteria.js.map